<template>
    <div
        :id="id"
        class="lni-u-pl1"
        :class="classString"
    >
        <button
            type="button"
            :aria-controls="`${id}_modal`"
            class="lni-u-link-style lni-u-pa0"
            @click="displayModal"
        >
            <span v-if="label.length > 0">
                {{ label }}
            </span>
            <span
                aria-hidden="true"
                class="lnicon--help"
            />
        </button>
        <lni-modal
            :id="`${id}_modal`"
            :title="title"
            :allowClose="true"
            :compact="true"
            :visible="false"
        >
            <template slot="content">
                <lni-html-element
                    :id="`${id}_info-body`"
                    :htmlString="body"
                />
            </template>
        </lni-modal>
    </div>
</template>

<script>
export default {
    name: 'LniJanitorialInfoModal',
    props: {
        body: {
            type: String,
            default: '',
        },
        classString: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
    },
    methods: {
        displayModal() {
            this.$store.commit('setAttribute', {
                id: `${this.id}_modal`,
                attribute: 'visible',
                value: true,
            }, {
                root: true,
            });
        },
    },
};
</script>